const isPrimaryServer = window.location.href.includes('rental.stoeckli.ch');
const isDivioLive = window.location.href.includes('ski-rental.eu.aldryn.io');
const isDivioStage = window.location.href.includes('ski-rental-stage.eu.aldryn.io');
const isDevelopment = window.location.href.includes('localhost:8000');

const isServer = isPrimaryServer || isDivioStage || isDivioLive
const environment = isPrimaryServer
    ? 'production'
    : isDivioLive
        ? 'divio-live'
        : isDivioStage
            ? 'divio-stage'
            : isDevelopment && 'development'

if (isServer) {
    const Raven = require('raven-js');
    const vuePlugin = require('raven-js/plugins/vue');

    Raven
        .config('https://1d5a3b7c7a6442aaa29b5ba740acaea6@o155039.ingest.sentry.io/1210580')
        .addPlugin(vuePlugin)
        .setEnvironment(environment)
        .install();

    window.Raven = Raven;
}

// this will let us have a global jQuery object
window.$ = window.jQuery = require("jquery");

// Modernizr global :)
window.Modernizr = require('modernizr');

// this loads bootstrap-sass
require("bootstrap-loader");

window.moment = require('moment-timezone');

window.Vue = require('vue');
if (location.hostname == "localhost") {
    window.Vue.config.debug = true;
}

window.Resource = require('vue-resource');
Vue.use(Resource);

var VueScrollTo = require('vue-scrollto');
window.Vue.use(VueScrollTo);

window.VueFormWizard = require('vue-form-wizard');
require('vue-form-wizard/dist/vue-form-wizard.min.css');
Vue.use(VueFormWizard);

window.VueFormGenerator = require('vue-form-generator');
require('vue-form-generator/dist/vfg.css');
Vue.use(VueFormGenerator);

// FIXME: For some reason it doesn't work and raises "VueI18n is not a constructor"
// Temporarly the base.html includes the script tag directly through
// https://unpkg.com/vue-i18n/dist/vue-i18n.js
// window.VueI18n = require('vue-i18n');
// Vue.use(VueI18n);

window.remodal = require('remodal/dist/remodal.js');
require("remodal/dist/remodal.css");
require("remodal/dist/remodal-default-theme.css");

// bootstrap-select component (http://silviomoreto.github.io/bootstrap-select/)
require("bootstrap-select");
require("./js/bootstrap-select-mobile");

// Isotope
// http://imagesloaded.desandro.com/#webpack
window.imagesLoaded = require('imagesloaded');
// http://isotope.metafizzy.co/extras.html#webpack
window.Isotope = require('isotope-layout');

// bootstrap datepicker component
// jQuery.fn.datetimepicker = require('eonasdan-bootstrap-datetimepicker');
// require("eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");
require("eonasdan-bootstrap-datetimepicker");
require("eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css");
// require('bootstrap-datepicker-webpack');
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker3.css');
require('normalize-css');
require('jquery-match-height');
require('./js/datetimepicker');
require('./js/testimonials-carousel.js');

require('./js/birthdate.js');
require('./js/integer-form-fields.js');

// this loads the django csrf protection methods for sending forms
require('./js/getcookie.js');

require('./js/tooltip.js');

// footer height calculation
require('./js/footer.js');

// Season rental feature
require('./js/season_rental/main.js');
const seasonalRentalMap = require('./js/season_rental/homepage/google_map')
// webfonts

// font-family: 'sofia_probold';
require('./fonts/sofia-pro-bold/_webfonts/sofiapro_bold_macroman/stylesheet.css');
// font-family: 'sofia_pro_regularregular';
require('./fonts/sofia-pro-regular/_webfonts/sofiapro_regular_macroman/stylesheet.css');
// font-family: "League Spartan"
require('./fonts/league-spartan/_webfonts/stylesheet.css');
// font-family: "DIN-Pro"
require('./fonts/din-pro/stylesheet.css');

// Homepage map
const homepageGoogleMap = require('./js/homepage_google_map');


window.googleMapOnLoad = () => {
    homepageGoogleMap.initHomepageMap();
    seasonalRentalMap.initMapNew();
}
const gettext = () => {};
gettext("This sample string tricks django into creating a valid djangojs.po file.");



// WEBPACK FOOTER //
// ./private/main.js